// extracted by mini-css-extract-plugin
export default {"mCard":"at-z","image":"bt-z","imageNoBackground":"ct-z","fullWidth":"dt-z"};